module.exports = __webpack_public_path__ + "static/lifeworks-logo-fr-99c5f4e0e8d89749eb7b21e608b0028f.png";